export default {
    add_patient: "Add patient",
    add_task: "Add task",
    calls: "Calls",
    chat_panel: "Chat panel",
    clinic_id: "Clinic Id",
    confirm: "Confirm",
    expenses: "Expenses",
    high: "High",
    low: "Low",
    medium: "Medium",
    no_notifications: "No notifications",
    read_all: "Read all",
    remove_confirmation: "Cancel confirmation",
    tasks: "Tasks"
}
